import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useEffect, useRef, useState } from 'react';
import Step1 from './Steps/Step1/Step1';
import Step2 from './Steps/Step2';
import Step3 from './Steps/Step3';
import Step4 from './Steps/Step4';

import Btn from '../../../Components/Ui_elements/Btn';
import Step5 from './Steps/Step5';
import { Card, CardHeader, CardContent, CardActions, Button, Step, StepLabel, Stepper, styled, Box } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ChevronStep = styled(Box)(({ theme, active }) => ({
  position: 'relative',
  padding: '10px 20px',
  marginRight: '10px',
  backgroundColor: active ? theme.palette.primary.main : '#fff',
  color: active ? '#fff' : '#000',
  fontWeight: 500,
  clipPath: 'polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 10% 50%)',
  border: active ? 'none' : '1px solid #e0e0e0',
  cursor: 'pointer',
  minWidth: 130,
  textAlign: 'center',
  fontSize:'0.875rem',
}));

const AddUpdateExternalResource = () => {
  const { user } = useSelector(state => state.root.authUser);
  const buttonref = useRef(null);
  const [isFreelancer, setisFreelancer] = useState("freelancer"); // Default: freelancer
  const { id } = useParams(); // For edit mode
  const [searchParams, setSearchParams] = useSearchParams();
  const stepFromUrl = parseInt(searchParams.get("step")) || 0;
  const c_id = searchParams.get("c_id");
  const navigate = useNavigate();

  const isEditMode = Boolean(id);
  const [activeStep, setActiveStep] = useState(stepFromUrl);
  const stepSubmitHandlers = useRef({});

  // Register a handler for each step
  const registerStepSubmitHandler = (stepIndex, handler) => {
    stepSubmitHandlers.current[stepIndex] = handler;
  };

  // Submit current step
  const submitCurrentStep = async () => {
    const submitHandler = stepSubmitHandlers.current[activeStep];
    if (submitHandler) {
      const isValid = await submitHandler();
      return isValid;
    }
    return false;
  };

  // Sync active step with URL param on change
  useEffect(() => {
    if (stepFromUrl !== activeStep) {
      setActiveStep(stepFromUrl);
    }
  }, [stepFromUrl]);

  const updateStep = (step) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("step", step);
    setSearchParams(newParams, { replace: true });
    setActiveStep(step);
  };

  const handleSave = async () => {
    await submitCurrentStep();
  };
  
  const handleSaveAndNextOrFinish = async () => {
  const valid = await submitCurrentStep();
  if (valid) {
    if (activeStep === steps.length - 1) {
      // Final step - navigate after successful validation
      const target = user?.iFkUserTypeId === 2 ? "/profile" : "/resources/external";
      navigate(target);
    } else {
      updateStep(activeStep + 1);
    }
  }
};

const handleNextOnly = async () => {
  if (activeStep === steps.length - 1) {
    const valid = await submitCurrentStep();
    if (valid) {
      const target = user?.iFkUserTypeId === 2 ? "/profile" : "/resources/external";
      navigate(target);
    }
  } else {
    updateStep(activeStep + 1);
  }
};

  const goToStep = (step) => {
    if (isEditMode || c_id) {
      updateStep(step);
    }
  };

  const isOpenFromProfile = localStorage.getItem('isProfilePage') === 'true';

  const steps =
    isFreelancer === "freelancer"
      ? [
        "Communication",
        "Properties",
        ...(isOpenFromProfile ? [] : ["Price List"]),
        "Payment Information",
      ]
      : [
        "Communication",
        "Contact Person",
        "Properties",
        ...(isOpenFromProfile ? [] : ["Price List"]),
        "Payment Information",
      ];

  const getStepContent = (stepIndex) => {
    const props = {
      activeStep,
      registerSubmit: (fn) => registerStepSubmitHandler(stepIndex, fn),
    };

    const stepContentMap = {
      "Communication": (
        <Step1
          {...props}
          isFreelancer={isFreelancer}
          setisFreelancer={setisFreelancer}
          buttonref={buttonref}
        />
      ),
      "Contact Person": <Step5 {...props} buttonref={buttonref} />,
      "Properties": <Step2 {...props} buttonref={buttonref} />,
      "Price List": <Step3 {...props} buttonref={buttonref} />,
      "Payment Information": <Step4 {...props} buttonref={buttonref} />,
    };

    const currentStepLabel = steps[stepIndex];
    return stepContentMap[currentStepLabel] || null;
  };

  return (
    <>
      <Card>
        <CardHeader
          title={
            isEditMode == true
              ? `Edit External Resource - ${localStorage.getItem("resourceName")}`
              : `Add External Resource`
          }
          action={
            <Btn
              variant="outlined"
              color="primary"
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => window.history.back()}
            >
              Back
            </Btn>
          }
        ></CardHeader>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={2}
          bgcolor="#f5f5fa"
        >
          {steps.map((label, index) => (
            <ChevronStep
              key={label}
              active={index === activeStep}
              onClick={() => (isEditMode || c_id) && goToStep(index)}
            >
              {label}
            </ChevronStep>
          ))}
        </Box>

        <CardContent sx={{ background:"#f4f4fb"}}>{getStepContent(activeStep)}</CardContent>

        <CardActions sx={{ justifyContent: 'space-between', borderTop: '1px solid #e0e0e0' }}>
          <Button
            disabled={activeStep === 0}
            onClick={() => updateStep(activeStep - 1)}
            variant="contained"
            color="default"
            sx={{
              cursor: activeStep === 0 ? 'not-allowed' : 'pointer',
              '&.Mui-disabled': {
                cursor: 'not-allowed',
                pointerEvents: 'auto',
              },
            }}
          >
            Back
          </Button>

          <div style={{ display: 'flex', gap: '10px' }}>
            <Button variant="outlined" onClick={handleSave}>
              Save
            </Button>
            {!(activeStep === steps.length - 1) &&
              <Button
                variant="contained"
                color="primary"
                // onClick={activeStep === steps.length - 1 ? () => user?.iFkUserTypeId === 2 ? navigate("/profile") : navigate("/resources/external") : handleSaveAndNext}
                onClick={handleSaveAndNextOrFinish}
              >
                {activeStep === steps.length - 1 ? "Finish" : "Save & Next"}
              </Button>
            }
            {((activeStep !== 0 && c_id) || isEditMode) &&
              <Button
                variant="outlined"
                // onClick={activeStep === steps.length - 1 ? () => user?.iFkUserTypeId === 2 ? navigate("/profile") : navigate("/resources/external") : handleSaveAndNext}
                onClick={handleNextOnly}
              >
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>}
          </div>
        </CardActions>
      </Card>
    </>
  );
};

export default AddUpdateExternalResource;
